import React, { Component } from "react";
import { Grid } from "@material-ui/core";
import DashboardData from './dashboard-data/DashboardData';

import './Dashboard.scss';
import Sidebar from "../components/sidebar/Sidebar";

export class Dashboard extends Component {
    constructor(props) {
        super(props);
        this.state = {};

        this.mapData = this.mapData.bind(this);
        this.clearData = this.clearData.bind(this);
    }

    componentWillMount() {
        const data = this.mapData(this.props.data);

        if (data && data[0].ItemTotal) {
            this.setState({ data });
        }
    }

    render() {
        if (this.state.data) {
            return (
                <Grid container spacing={0} className="dashboard-wrapper">
                    <Grid item xs={2}>
                        <Sidebar orders={this.state.data} onDataClear={this.clearData} />
                    </Grid>

                    <Grid item xs={10}>
                        <DashboardData data={this.state.data} />
                    </Grid>
                </Grid>
            )
        } else {
            this.clearData(true);
            alert('Invalid report provided. Please make sure you generate the "Items" report type.');
            return null;
        }
    }

    clearData(event) {
        this.props.dataCleared(event);
    }

    mapData(data) {
        const keys = data.shift().map(key => key.split(' ').join(''));
        const mappedDataArr = [];

        // Fixes ASIN/ISBN column name
        const i = keys.indexOf('ASIN/ISBN');
        keys[i] = 'Asin';

        data.forEach(row => {
            const mappedData = {};

            row.forEach((value, index) => {
                if (value.startsWith('$')) {
                    value = value.replace('$', '');
                }
                mappedData[keys[index]] = value;
            });

            mappedDataArr.push(mappedData);
        });

        return mappedDataArr;
    }
}
